import { Card, CardBody, Col } from "reactstrap";
import { Brand } from "../../../../constants";
import { BrandList, BrandServiceHighlights  } from "../../../../data/applications/ECommerce";

// This component displays a list of brands and their service highlights in a card layout.
const BrandLists = () => {
  return (
    <Col xxl="3" md="6" className="box-col-12">
      <Card>
        <CardBody>
          <div className="filter-block">
            <h3>{Brand}</h3>
            <ul>
              {BrandList.map((item, index) => (<li key={index}>{item}</li>))}
            </ul>
          </div>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <div className="collection-filter-block">
            <ul className="pro-services">
              {BrandServiceHighlights.map((item, index) => (
                <li key={index}>
                  <div className="d-flex">
                    {item.icon}
                    <div className="flex-grow-1">
                      <h5>{item.text}</h5>
                      <p>{item.span}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BrandLists;